declare global {
  interface Window {
    nativeWebViewMessageHandler?: {
      postMessage: (message: string) => void;
    };
    webkit?: {
      messageHandlers?: {
        nativeWebViewMessageHandler?: {
          postMessage: (message: string) => void;
        };
      };
    };
  }
}

const sendNativeEvent = (message: any) => {
  try {
    // Android
    if (typeof window.nativeWebViewMessageHandler?.postMessage === 'function') {
      window.nativeWebViewMessageHandler.postMessage(JSON.stringify(message));
    }

    // iOS
    if (
      typeof window.webkit?.messageHandlers?.nativeWebViewMessageHandler
        ?.postMessage === 'function'
    ) {
      window.webkit.messageHandlers.nativeWebViewMessageHandler.postMessage(
        JSON.stringify(message)
      );
    }
  } catch {}
};

export default sendNativeEvent;
